import { message } from 'antd';

import { createCaveat } from '../../../HttpRequests/caveats';
import handleException from '../../../Core/Helpers/handleException';

export default (data) => async () => {

  try {

    await createCaveat({ data });

    message.success('Caveat Created');

    return true;
    
  } catch (error) {
    
    handleException(error);

    return false;

  }
}
